const mockHeads = {
    1: { 
        "id": 1, 
        "dna": "60f23f_707120706769_gen-0", 
        "owner": "123", 
        "level": 1, 
        "dob": "2018-06-22T06:17:00.000Z", 
        "isLocked": false, 
        "lockedInWar": 1 
    },
    2: { 
        "id": 1, 
        "dna": "ba89f9_984305346321_gen-0", 
        "owner": "123", 
        "level": 1, 
        "dob": "2018-06-22T06:17:00.000Z", 
        "isLocked": false, 
        "lockedInWar": 1 
    },
    3: { 
        "id": 1, 
        "dna": "ea6ecc_645092659835_gen-0", 
        "owner": "123", 
        "level": 1, 
        "dob": "2018-06-22T06:17:00.000Z", 
        "isLocked": false, 
        "lockedInWar": 1 
    },
    4: { 
        "id": 1, 
        "dna": "733160_296657184726_gen-0", 
        "owner": "123", 
        "level": 1, 
        "dob": "2018-06-22T06:17:00.000Z", 
        "isLocked": false, 
        "lockedInWar": 1 
    },
    5: { 
        "id": 1, 
        "dna": "baeff9_298463028644_gen-0", 
        "owner": "123", 
        "level": 1, 
        "dob": "2018-06-22T06:17:00.000Z", 
        "isLocked": false, 
        "lockedInWar": 1 
    }
};

export { mockHeads };


// WEBPACK FOOTER //
// ./src/util/mockHeads.js